export const save = {
  name: "save" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.364 3.364A.9.9 0 0 1 4 3.1h13a.9.9 0 0 1 .636.264l3 3A.9.9 0 0 1 20.9 7v13a.9.9 0 0 1-.9.9H4a.9.9 0 0 1-.9-.9V4a.9.9 0 0 1 .264-.636ZM4.9 4.9v14.2h1.7v-5.6a.9.9 0 0 1 .9-.9h9a.9.9 0 0 1 .9.9v5.6h1.7V7.373L16.627 4.9H8.4v2.7H16a.9.9 0 1 1 0 1.8H7.5a.9.9 0 0 1-.9-.9V4.9H4.9Zm10.7 14.2v-4.7H8.4v4.7h7.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["save"],
  category: "action" as const,
};
